import { render } from "./UserInfo.vue?vue&type=template&id=38e1a263"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
script.render = render

export default script